import React from "react";
import { Link } from "gatsby";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import { MDXProvider } from "@mdx-js/react";
import Helmet from "react-helmet";
import styled, { createGlobalStyle } from "styled-components";
import shortcodes from "./shortcodes";

const GlobalStyle = createGlobalStyle`
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
  *, *::before, *::after: {
    boxSizing: inherit;
  }
  strong, b: {
   font-weight: 600;
  }
  body {
    margin: 0;
    background-color: #CA7;
    font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ",
      Meiryo, "ＭＳ Ｐゴシック", sans-serif;
  }
  h1 {
    margin-top: 30px;
  }
  h2 {
    margin-top: 30px;
  }
  h3 {
    margin-top: 30px;
  }
  h4 {
    margin-top: 30px;
  }
  h5 {
    margin-top: 30px;
  }
  h6 {
    margin-top: 30px;
  }
`;

const theme = createMuiTheme({});

const Container = styled.div`
  margin: 0;
  padding: 20px 40px;
  @media only screen and (max-width: 600px) {
    padding: 10px;
  }
`;

const Article = styled(Paper)`
  margin: 20px auto;
  max-width: 800px;
  padding: 20px 40px;
  @media only screen and (max-width: 600px) {
    margin: 10px auto;
    padding: 10px 20px;
  }
`;

const Copyright = styled.div`
  margin-top: 80px;
  text-align: right;
  font-size: 0.8em;
  font-family: Helvetica, Arial, sans-serif;
`;

const AppMenuContainer = styled.div`
  margin: 4px auto;
  max-width: 840px;
  font-size: 0.9em;
`;

const AppMenu = () => {
  return (
    <AppMenuContainer>
      <Link to="/">原語 de オペラ Top</Link> |{" "}
      <a
        href="https://opera-db.capriccioso.info"
        target="_blank"
        rel="noopener noreferrer"
      >
        オペラ公演情報データベース
      </a>
    </AppMenuContainer>
  );
};

const Layout = ({ children }) => {
  return (
    <Container>
      <GlobalStyle />
      <Helmet
        htmlAttributes={{
          lang: "ja",
        }}
        title="原語 de オペラ"
      >
        <meta name="theme-color" content="#a52a2a" />
      </Helmet>
      <AppMenu />
      <Article>
        {children}
        <Copyright>Copyright &copy; 2020 Aile</Copyright>
      </Article>
    </Container>
  );
};

export default ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <MDXProvider components={shortcodes}>
        <Layout>{children}</Layout>
      </MDXProvider>
    </ThemeProvider>
  );
};
